import { render, staticRenderFns } from "./confirm-step.vue?vue&type=template&id=657e549a&scoped=true&lang=pug&"
import script from "./confirm-step.vue?vue&type=script&lang=js&"
export * from "./confirm-step.vue?vue&type=script&lang=js&"
import style0 from "./confirm-step.vue?vue&type=style&index=0&id=657e549a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657e549a",
  null
  
)

export default component.exports